import { createSlice } from "@reduxjs/toolkit";
import ServerRoutes from "../api/routes";
import { get, post } from "../api/http";

const initialState = {
  efrats: {},
  usersError: null,
  usersLoading: false,
};

const _setUsers = (state, action) => {
  state.efrats = action.payload;
  state.usersLoading = false;
};

const _editUser = (state, action) => {
  let editedUsers = { ...state.efrats };
  for (const [key, value] of Object.entries(action.payload.body))
    editedUsers[action.payload._id][key] = value;
  state.efrats = editedUsers;
  state.usersChange = !state.usersChange;
};

const _actionStart = (state, action) => {
  state.usersLoading = true;
  state.usersError = null;
};

const _actionSuccess = (state, action) => {
  state.usersLoading = false;
  state.usersError = null;
};

const _actionFailed = (state, action) => {
  state.usersLoading = false;
  state.usersError = action.payload.error;
};

const _deleteUser = (state, action) => {
  let editedUsers = { ...state.efrats };
  delete editedUsers[action.payload];
  state.efrats = editedUsers;
};

const efrats = createSlice({
  name: "efrats",
  initialState,
  reducers: {
    setUsers: _setUsers,
    editUser: _editUser,
    deleteUser1: _deleteUser,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = efrats;

export const {
  setUsers,
  editUser,
  deleteUser1,
  actionStart,
  actionFailed,
  actionSuccess,
} = actions;

export default reducer;

export const getAllEfrat = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(ServerRoutes.Efrat.getAll, {});
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setUsers(data));
  };
};

export const destroyUser = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Efrat.destroyUser, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(deleteUser1(body.id));
    }
  };
};

export const editUserById = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Efrat.edit + _id, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editUser({
          _id,
          body,
        })
      );
    }
  };
};

export const sendWelcome = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Efrat.sendWelcome, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const sendMsg = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Efrat.send, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const cancelTizmun = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.Efrat.cancel, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const add = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Efrat.add, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};
